// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] || chunkId) + "." + {"43":"25761037","213":"031b229d","234":"23815d60","239":"22e919a0","653":"3fc38977","732":"03aa833c","844":"ba01263a"}[chunkId] + ".chunk.js";
};